import { defineStore } from 'pinia'
import { useUserStore } from "@/stores/user";
import router from "@/router";

export const useInvoicesStore = defineStore('invoices', {
  state: () => ({
    items: [],
    openInvoices: [],
    latestInvoice: null,
    totalRecords: 0,
    loading: false,
    overviewLoading: false,
    serverOptions: {
      page: 0,
      rows: 20,
      sortField: 'number',
      sortOrder: -1,
    },
  }),
  actions: {
    async fetchOverview() {
      this.overviewLoading = true

      try {
        const organisation = useUserStore().user.organisation
        const kdnr = organisation?.kdnr || router.currentRoute.value.query.kdnr

        if (!kdnr) {
          this.openInvoices = []
          this.latestInvoice = null
          return {data: {open_invoices: [], latest_invoice: null}}
        }

        const rawResponse = await this.apiClientV2.get('/invoices/overview', {params: {kdnr}})
        const responseData = rawResponse?.data || {}

        this.openInvoices = (responseData.open_invoices || []).filter((invoice) => invoice?.number)
        this.latestInvoice = responseData.latest_invoice?.number ? responseData.latest_invoice : null

        return rawResponse
      } finally {
        this.overviewLoading = false
      }
    },
    async index(filters = {}) {
      this.loading = true

      try {
        const response = await this.fetchInvoices(this.serverOptions, filters)

        this.items = response.visibleInvoices
        this.totalRecords = response.totalRecords

        return response.rawResponse
      } finally {
        this.loading = false
      }
    },
    async fetchInvoices(options = this.serverOptions, filters = {}) {
      const organisation = useUserStore().user.organisation
      const kdnr = organisation?.kdnr || router.currentRoute.value.query.kdnr

      if (!kdnr) {
        return {
          rawResponse: {data: {invoices: [], totalRecords: 0}},
          visibleInvoices: [],
          totalRecords: 0,
        }
      }

      const params = {
        kdnr,
        page: options.page + 1,
        size: options.rows,
        sort_by: options.sortField || 'number',
        sort_order: options.sortOrder || -1,
      }

      if (filters.invoiceDateFrom) {
        params.invoice_date_from = filters.invoiceDateFrom
      }

      if (filters.invoiceDateTo) {
        params.invoice_date_to = filters.invoiceDateTo
      }

      const rawResponse = await this.apiClientV2.get('/invoices', {params})
      const responseData = rawResponse?.data
      const invoices = Array.isArray(responseData)
        ? responseData
        : responseData?.invoices || responseData?.items || []

      const visibleInvoices = invoices.filter((invoice) => invoice?.number)

      const totalRecords = Number(
        responseData?.totalRecords
        || responseData?.total_count
        || responseData?.pagination?.total_records
        || responseData?.meta?.total
        || visibleInvoices.length
      )

      return {
        rawResponse,
        visibleInvoices,
        totalRecords,
      }
    },
  },
})
